// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ih0mQ","tabsBox":"styles_tabsBox__3nzWT","createButton":"styles_createButton__XEI2D"};